import {
  GET_PRODUCT_GROUP_COMPONENTS,
  PRODUCT_GROUP_COMPONENTS_LOADING,
  ProductGroupComponent,
  RESET_PRODUCT_GROUP_COMPONENTS,
} from "./ProductGroupComponentsTypes";

export interface ProductGroupComponentsState {
  components: ProductGroupComponent[];
  loading: boolean;
}

const initialState: ProductGroupComponentsState = {
  components: [],
  loading: false,
};

export const ProductGroupComponentsReducer = (
  state: ProductGroupComponentsState = initialState,
  action,
) => {
  switch (action.type) {
    case GET_PRODUCT_GROUP_COMPONENTS.SUCCESS:
      return {
        ...state,
        components: action.payload.components,
      };
    case GET_PRODUCT_GROUP_COMPONENTS.FAILURE:
      return {
        ...state,
        loading: false,
      };
    case PRODUCT_GROUP_COMPONENTS_LOADING:
      return {
        ...state,
        loading: action.payload.isLoading,
      };
    case RESET_PRODUCT_GROUP_COMPONENTS:
      return {
        ...state,
        components: [],
      };
    default:
      return state;
  }
};
